import React from "react";
import { assets } from "../../../Assets/assets";

const LifeCard = ({ index, img, text }) => {
  return (
    <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} className="snap-center shrink-0 w-full md:w-[21.5rem] lg:w-[19rem] xl:w-[31%] rounded-xl hover:shadow-xl transition duration-500 overflow-hidden group relative">

      <div className="absolute top-0 right-0 w-[45px] h-[45px] flex items-center justify-center">
        <img src={assets.logo} className="w-8 h-8" alt="badge" />
      </div>

      <div className="w-full h-[210px] xl:h-[15rem] overflow-hidden">
        <img
          src={img}
          className="w-full h-full transition-all duration-500 group-hover:drop-shadow-lg"
          alt="Life Moment"
        />
      </div>

      <div className="p-4">
        <p className="text-primaryNavyTextColor text-[15px] font-medium leading-6">
          {text}
        </p>
      </div>

    </div>
  );
};

export default LifeCard;
